import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

import { selectorPayrollRunStatusColor } from "../../selectors/selectorPayrollRunStatusColor";
import { selectorPayrollRunStatusPill } from "../../selectors/selectorPayrollRunStatusPill";
import { PayrollRunSummary } from "../../types";

export const getColumns = (): WSTableColumn<PayrollRunSummary>[] => [
  {
    config: { header: { text: "Payrolls" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        secondaryText={rowItem.data.isOffCycle ? "Off-Cycle" : undefined}
        text={rowItem.data.payrollId}
      />
    )
  },
  {
    config: { header: { text: "Pay period" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell text={rowItem.data.payPeriodRange} />
    )
  },
  {
    config: { header: { text: "Status" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        pill={selectorPayrollRunStatusPill(rowItem.data.status)}
        secondaryText={rowItem.data.statusDetail}
        secondaryTextColor={selectorPayrollRunStatusColor(rowItem.data.status)}
      />
    )
  },
  {
    config: {
      header: { text: "Total # of paystubs" },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: rowItem => (
      <WSTableCell text={`${rowItem.data.paystubsCount}`} />
    )
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(rowItem.data.liabilityAmount, Currency.USD)}
      />
    )
  }
];
